"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RuleEditForm = void 0;
const core_1 = require("@material-ui/core");
const confirmation_modal_1 = require("client/components/confirmation-modal");
const icons_1 = require("client/components/icons");
const button_1 = require("client/components/material/button");
const select_1 = require("client/components/material/select");
const text_area_1 = require("client/components/material/text-area");
const text_field_1 = require("client/components/material/text-field");
const callable_1 = require("client/components/ui/callable");
const form_1 = require("client/components/ui/form");
const store_1 = require("client/modules/inventory-order/store");
const material_ui_1 = require("material-ui");
const Add_1 = require("material-ui-icons/Add");
const Delete_1 = require("material-ui-icons/Delete");
const Collapse_1 = require("material-ui/transitions/Collapse");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const ReactTooltip = require("react-tooltip");
require("./rule-edit-form.less");
let RuleEditForm = class RuleEditForm extends React.Component {
    constructor() {
        super(...arguments);
        this.rule = {
            id: null,
            name: "",
            description: "",
            category: "order",
            inventoryGroup: "",
            inventoryCode: "",
            quantity: 0,
            quantityEvaluation: "max",
            budgetEvaluation: "cost",
            budget: 0,
            frequency: "order",
            notifications: [
                {
                    method: "alert",
                    value: ""
                }
            ]
        };
        this.isMissing = { name: true, category: true, quantity: true, notification: true };
        this.status = form_1.FormStatus.Clean;
        this.submitClicked = false;
        this.errorMessage = "";
        this.showAddNotificationMethodForm = false;
        this.notificationMethodAdd = { method: "alert", value: "" };
        this.showRuleDeleteConfirmation = false;
        this.ruleToDelete = null;
        this.initializeRule = () => {
            if (this.props.rule) {
                const { id, name, description, category, inventoryGroup, inventoryCode, quantity, quantityEvaluation, budget, budgetEvaluation, frequency, notifications } = this.props.rule;
                this.rule = Object.assign(Object.assign({}, this.rule), { id: id || this.rule.id, name: name || "", description: description || "", category: category || "order", inventoryGroup,
                    inventoryCode, quantity: quantity || 0, quantityEvaluation: quantityEvaluation || "max", budget: budget || 0, budgetEvaluation: budgetEvaluation || "cost", frequency: frequency || "order", notifications: notifications.length
                        ? notifications
                        : this.rule.notifications });
            }
        };
        this.initializeRuleUpdated = (rule) => {
            if (rule) {
                const { name, description, category, inventoryGroup, inventoryCode, quantity, quantityEvaluation, budget, budgetEvaluation, frequency, notifications } = rule;
                this.rule = Object.assign(Object.assign({}, this.rule), { name: name || "", description: description || "", category: category || "order", inventoryGroup,
                    inventoryCode, quantity: quantity || 0, quantityEvaluation: quantityEvaluation || "max", budget: budget || 0, budgetEvaluation: budgetEvaluation || "cost", frequency: frequency || "order", notifications: notifications.length
                        ? notifications
                        : this.rule.notifications });
            }
        };
        this.checkMissing = () => {
            let categoryMissing = true;
            switch (this.rule.category) {
                case "order":
                case "group":
                case "code":
                    categoryMissing = !this.rule.category;
                    break;
                default:
                    categoryMissing = true;
            }
            this.isMissing.category = categoryMissing;
            this.isMissing.name = !this.rule.name;
            this.isMissing.notification = !this.rule.notifications;
            this.isMissing.quantity = !this.rule.quantity;
        };
        this.handleDelete = async () => {
            if (this.rule.id) {
                await store_1.inventoryOrderStore.deleteRule(this.rule);
                this.showRuleDeleteConfirmation = false;
                this.props.loadPurchaseRules && this.props.loadPurchaseRules();
            }
            else {
                alert("rule id is null; cannot delete");
            }
        };
        this.handleRuleChange = (field, index) => (event, value) => {
            if (field === "notificationValue") {
                this.rule.notifications[index].value = value;
            }
            else if (field === "notificationMethod") {
                this.rule.notifications[index].method = value;
            }
            else {
                this.rule[field] = value;
            }
            this.checkMissing();
        };
        this.handleSubmit = async () => {
            this.submitClicked = true;
            this.checkMissing();
            if (this.isMissingRequiredField) {
                this.errorMessage = "Missing required fields.";
                return;
            }
            this.errorMessage = "";
            try {
                // determine whether rule should be updated or created
                // console.log("this.rule", this.rule);
                // If rule exists, save it; otherwise create it
                if (this.rule.id) {
                    await store_1.inventoryOrderStore.saveRule(this.rule);
                }
                else {
                    await store_1.inventoryOrderStore.createRule(this.rule);
                }
                // reload rules
                this.props.loadPurchaseRules && this.props.loadPurchaseRules();
                callable_1.callable(this.props.onCancel)();
            }
            catch (e) {
                throw new Error(e);
            }
        };
        this.isChanged = () => {
            return true;
        };
        this.renderCategorySelect = () => (React.createElement(React.Fragment, null,
            React.createElement(core_1.FormControl, { component: "fieldset" },
                React.createElement(core_1.FormLabel, { component: "legend" }, "Category"),
                React.createElement(core_1.RadioGroup, { "aria-label": "Category", name: "category", value: this.rule.category, onChange: this.handleRuleChange("category"), className: "form-radio-group" },
                    React.createElement(core_1.FormControlLabel, { value: "order", control: React.createElement(core_1.Radio, null), label: "Order" }),
                    React.createElement(core_1.FormControlLabel, { value: "group", control: React.createElement(core_1.Radio, null), label: "Inventory group" }),
                    React.createElement(core_1.FormControlLabel, { value: "code", control: React.createElement(core_1.Radio, null), label: "NDC code" })))));
        this.handleGroupSelection = (group) => {
            this.rule.inventoryGroup = group;
        };
        /** Render content dependent of the category selected */
        this.renderSubcategorySelect = () => (React.createElement("div", { className: "sub-category-content" },
            this.rule.category === "group" && (React.createElement(select_1.MaterialSelect, { className: "orders-submit__site-select", label: "Select inventory group", options: this.availableOptions, value: this.rule.inventoryGroup, onSelect: this.handleGroupSelection })),
            this.rule.category === "code" && (React.createElement(text_field_1.MaterialTextField, { value: this.rule.inventoryCode || "", onChange: this.handleRuleChange("inventoryCode"), className: "input-field ndc-code", label: "Enter NDC code" })),
            React.createElement(text_field_1.MaterialTextField, { className: "input-field", value: this.rule.quantity, onChange: this.handleRuleChange("quantity"), label: "Enter quantity", type: "number", numType: "integer", required: true }),
            React.createElement(core_1.FormControl, { component: "fieldset" },
                React.createElement(core_1.FormLabel, { component: "legend" }, "Quantity evaluation"),
                React.createElement(core_1.RadioGroup, { "aria-label": "Quantity Evaluation", name: "quantityEvaluation", value: this.rule.quantityEvaluation, onChange: this.handleRuleChange("quantityEvaluation"), className: "form-radio-group" },
                    React.createElement(core_1.FormControlLabel, { value: "min", control: React.createElement(core_1.Radio, null), label: "Evaluate as Minimum" }),
                    React.createElement(core_1.FormControlLabel, { value: "max", control: React.createElement(core_1.Radio, null), label: "Evaluate as Maximum" })))));
        this.renderBudgetSelect = () => (React.createElement(React.Fragment, null,
            React.createElement(core_1.FormControl, { component: "fieldset" },
                React.createElement(core_1.FormLabel, { component: "legend" }, "Budget"),
                React.createElement(core_1.RadioGroup, { "aria-label": "Budget", name: "budgetEvaluation", value: this.rule.budgetEvaluation, onChange: this.handleRuleChange("budgetEvaluation"), className: "form-radio-group" },
                    React.createElement(core_1.FormControlLabel, { value: "cost", control: React.createElement(core_1.Radio, null), label: "Cost" }),
                    React.createElement(core_1.FormControlLabel, { value: "percentage", control: React.createElement(core_1.Radio, null), label: "Percentage" })))));
        /** Render content dependent of the qualifier selected */
        this.renderSubbudgetSelect = () => (React.createElement(React.Fragment, null,
            React.createElement(text_field_1.MaterialTextField, { className: "input-field", label: this.rule.budgetEvaluation === "cost"
                    ? "Enter budget dollar amount"
                    : this.rule.budgetEvaluation === "percentage"
                        ? "Enter budget percentage amount"
                        : "", leftItem: this.rule.budgetEvaluation === "cost" ? React.createElement(icons_1.DollarsIcon, null) : "", value: this.rule.budget, 
                // error={
                //   this.submitClicked && !validator.isCurrency(String(this.rule.budget))
                // }
                onChange: this.handleRuleChange("budget"), type: "text", numType: "price", required: true })));
        this.renderFrequencySelect = () => (React.createElement(core_1.FormControl, { component: "fieldset" },
            React.createElement(core_1.FormLabel, { component: "legend" }, "Frequency"),
            React.createElement(core_1.RadioGroup, { "aria-label": "Frequency", name: "category", value: this.rule.frequency, onChange: this.handleRuleChange("frequency"), className: "form-radio-group" },
                React.createElement(core_1.FormControlLabel, { value: "order", control: React.createElement(core_1.Radio, null), label: "Order" }),
                React.createElement(core_1.FormControlLabel, { value: "day", control: React.createElement(core_1.Radio, null), label: "Day" }),
                React.createElement(core_1.FormControlLabel, { value: "week", control: React.createElement(core_1.Radio, null), label: "Week" }),
                React.createElement(core_1.FormControlLabel, { value: "month", control: React.createElement(core_1.Radio, null), label: "Month" }),
                React.createElement(core_1.FormControlLabel, { value: "quarter", control: React.createElement(core_1.Radio, null), label: "Quarter" }),
                React.createElement(core_1.FormControlLabel, { value: "year", control: React.createElement(core_1.Radio, null), label: "Year" }))));
        this.handleRemoveNotificationMethod = (notification) => async () => {
            if (this.props.rule) {
                await store_1.inventoryOrderStore.removeNotificationMethod(this.rule, notification);
                this.props.loadPurchaseRules && this.props.loadPurchaseRules();
                this.initializeRule();
            }
            else {
                alert("cannot delete a notification without rule");
            }
        };
        this.renderNotificationMethodSelect = () => this.rule.notifications.map((notification, index) => (React.createElement("div", { className: "notification-method-item", key: index },
            React.createElement(core_1.FormControl, { component: "fieldset" },
                React.createElement(core_1.FormLabel, { component: "legend" }, "Notification Method"),
                React.createElement(core_1.RadioGroup, { "aria-label": "Notification Method", name: "notificationMethod", value: this.rule.notifications[index].method, onChange: this.handleRuleChange("notificationMethod", index), className: "form-radio-group" },
                    React.createElement(core_1.FormControlLabel, { value: "alert", control: React.createElement(core_1.Radio, null), label: "Alert" }),
                    React.createElement(core_1.FormControlLabel, { value: "email", control: React.createElement(core_1.Radio, null), label: "Email" })),
                React.createElement(text_field_1.MaterialTextField, { key: index, label: notification.method === "alert"
                        ? "Enter alert message for rule violation"
                        : notification.method === "email"
                            ? "Enter email"
                            : "", value: this.rule.notifications[index].value, onChange: this.handleRuleChange("notificationValue", index), required: true })),
            React.createElement(ReactTooltip, { id: "notification-remove-icon", className: "tooltip", effect: "solid", place: "right", delayShow: 300, "data-type": "info", multiline: true }),
            this.props.rule && this.rule.notifications.length > 1 && (React.createElement(material_ui_1.Button, { className: "delete-button-with-icon", "data-for": "notification-remove-icon", "data-tip": "Remove notification method", onClick: this.handleRemoveNotificationMethod(notification) },
                React.createElement(Delete_1.default, null))))));
        this.renderRuleParameterForm = () => (React.createElement("div", { className: "edit-rule-form__parameter" },
            React.createElement(core_1.Typography, { className: "edit-rule-form__parameter--title", variant: "headline" }, "Rule Parameters"),
            React.createElement("div", { className: "parameter-form" },
                React.createElement("div", { className: "text-field" },
                    React.createElement(text_field_1.MaterialTextField, { label: "Rule name", value: this.rule.name, onChange: this.handleRuleChange("name"), required: true }),
                    React.createElement(text_area_1.MaterialTextArea, { className: "textarea", value: this.rule.description, onChange: this.handleRuleChange("description"), placeholder: "Rule description" })),
                React.createElement("div", { className: "parameter-form__radio" },
                    this.renderCategorySelect(),
                    this.renderSubcategorySelect(),
                    this.renderBudgetSelect(),
                    this.renderSubbudgetSelect(),
                    this.renderFrequencySelect()))));
        this.handleNotificationMethodAddChange = (field) => (event, value) => {
            this.notificationMethodAdd[field] = value;
        };
        this.resetNotificationMethodAdd = () => {
            this.notificationMethodAdd = {
                method: "alert",
                value: ""
            };
        };
        this.handleSubmitNotificationMethodAdd = async () => {
            if (this.props.rule && this.notificationMethodAdd.value) {
                // save notification
                await store_1.inventoryOrderStore.addNotificationMethod(this.props.rule, this.notificationMethodAdd);
                this.props.loadPurchaseRules && this.props.loadPurchaseRules();
                this.showAddNotificationMethodForm = false;
                this.resetNotificationMethodAdd();
                // this.initializeRule();
            }
            else {
                if (!this.props.rule) {
                    alert("no rule to add notification for.");
                }
                if (!this.notificationMethodAdd.value) {
                    alert("value for notification method is required");
                }
            }
        };
        this.handleSubmitNotificationMethodAddCancel = () => {
            this.showAddNotificationMethodForm = false;
            this.resetNotificationMethodAdd();
        };
        this.renderNotificationEditForm = () => {
            const rule = this.props.rule || null;
            return (React.createElement("div", { className: "add-notification-container" },
                React.createElement(Collapse_1.default, { in: this.showAddNotificationMethodForm },
                    React.createElement(form_1.UiForm, { buttons: [
                            React.createElement(button_1.MaterialButton, { className: "btnCancel", onClick: this.handleSubmitNotificationMethodAddCancel }, "Cancel"),
                            "Save"
                        ], loading: false, isChanged: this.isChanged, status: this.status, saved: "Saved", onSubmit: this.handleSubmitNotificationMethodAdd, error: this.errorMessage, shouldDisableSave: false },
                        React.createElement(core_1.FormControl, { component: "fieldset" },
                            React.createElement(core_1.FormLabel, { component: "legend" }, "Add New Notification Method"),
                            React.createElement(core_1.RadioGroup, { "aria-label": "Notification Method", name: "notificationMethod", value: this.notificationMethodAdd.method, onChange: this.handleNotificationMethodAddChange("method"), className: "form-radio-group" },
                                React.createElement(core_1.FormControlLabel, { value: "alert", control: React.createElement(core_1.Radio, null), label: "Alert" }),
                                React.createElement(core_1.FormControlLabel, { value: "email", control: React.createElement(core_1.Radio, null), label: "Email" })),
                            React.createElement(text_field_1.MaterialTextField, { label: "test label", value: this.notificationMethodAdd.value, onChange: this.handleNotificationMethodAddChange("value") })))),
                React.createElement(button_1.MaterialButton, { fab: true, className: "notification-add-fab", primary: true, onClick: () => (this.showAddNotificationMethodForm = !this
                        .showAddNotificationMethodForm) },
                    React.createElement(Add_1.default, null))));
        };
        this.renderRuleNotificationForm = () => (React.createElement("div", { className: "edit-rule-form__notification" },
            React.createElement(core_1.Typography, { className: "edit-rule-form__notification--title", variant: "headline" }, "Rule Notifications"),
            React.createElement("div", { className: "notification-form" },
                this.renderNotificationMethodSelect(),
                this.props.rule && this.renderNotificationEditForm())));
        this.renderFormContent = () => (React.createElement("div", { className: "edit-rule-form" },
            React.createElement("div", { className: "edit-rule-form__content" },
                this.renderRuleParameterForm(),
                this.renderRuleNotificationForm())));
    }
    get isMissingRequiredField() {
        const isMissingField = Object.values(this.isMissing);
        return isMissingField.some(value => value === true);
    }
    get availableOptions() {
        return store_1.inventoryOrderStore.inventoryGroups.value
            ? store_1.inventoryOrderStore.inventoryGroups.value.map((group, i) => ({
                id: i,
                label: group.group,
                value: group.group.toString()
            }))
            : [];
    }
    async componentDidMount() {
        await store_1.inventoryOrderStore.listInventoryGroups();
        this.initializeRule();
    }
    componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps) {
            this.initializeRuleUpdated(nextProps.rule);
        }
    }
    render() {
        return (React.createElement(React.Fragment, null,
            React.createElement(form_1.UiForm, { buttons: [
                    React.createElement(button_1.MaterialButton, { className: "btnDelete", onClick: () => (this.showRuleDeleteConfirmation = true) }, "DELETE"),
                    React.createElement(button_1.MaterialButton, { className: "btnCancel", onClick: this.props.onCancel }, "Cancel"),
                    "Save"
                ], loading: false, isChanged: this.isChanged, status: this.status, saved: "Saved", onSubmit: this.handleSubmit, error: this.errorMessage, shouldDisableSave: this.submitClicked && this.isMissingRequiredField }, this.renderFormContent()),
            this.showRuleDeleteConfirmation && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Delete", cancelText: "Cancel", message: `Are you sure you want to delete this distributor?<br />This action cannot be undone.`, onCancel: () => {
                    this.ruleToDelete = null;
                    this.showRuleDeleteConfirmation = false;
                }, onConfirm: this.handleDelete, title: "Delete Confirmation" }))));
    }
};
__decorate([
    mobx_1.computed
], RuleEditForm.prototype, "isMissingRequiredField", null);
__decorate([
    mobx_1.computed
], RuleEditForm.prototype, "availableOptions", null);
__decorate([
    mobx_1.observable
], RuleEditForm.prototype, "rule", void 0);
__decorate([
    mobx_1.observable
], RuleEditForm.prototype, "isMissing", void 0);
__decorate([
    mobx_1.observable
], RuleEditForm.prototype, "status", void 0);
__decorate([
    mobx_1.observable
], RuleEditForm.prototype, "submitClicked", void 0);
__decorate([
    mobx_1.observable
], RuleEditForm.prototype, "errorMessage", void 0);
__decorate([
    mobx_1.observable
], RuleEditForm.prototype, "showAddNotificationMethodForm", void 0);
__decorate([
    mobx_1.observable
], RuleEditForm.prototype, "notificationMethodAdd", void 0);
__decorate([
    mobx_1.observable
], RuleEditForm.prototype, "showRuleDeleteConfirmation", void 0);
__decorate([
    mobx_1.observable
], RuleEditForm.prototype, "ruleToDelete", void 0);
__decorate([
    mobx_1.action
], RuleEditForm.prototype, "initializeRule", void 0);
__decorate([
    mobx_1.action
], RuleEditForm.prototype, "initializeRuleUpdated", void 0);
__decorate([
    mobx_1.action
], RuleEditForm.prototype, "checkMissing", void 0);
__decorate([
    mobx_1.action
], RuleEditForm.prototype, "handleRuleChange", void 0);
__decorate([
    mobx_1.action
], RuleEditForm.prototype, "handleSubmit", void 0);
__decorate([
    mobx_1.action
], RuleEditForm.prototype, "isChanged", void 0);
RuleEditForm = __decorate([
    mobx_react_1.observer
], RuleEditForm);
exports.RuleEditForm = RuleEditForm;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory-order/tabs/order-rules/modules/rule-edit-form/rule-edit-form.tsx
// module id = 3592
// module chunks = 0